<template>
  <div class="modal">
    <div class="modal-overlay" @click="$emit('close')"></div>
    <div class="modal-content">
      <div class="header">
        <div class="title">{{$props.title}}</div>
        <div class="subtitle">{{$props.subtitle}}</div>
        <button class="ccs-button ccs-button--white ccs-button--small"
          @click="$emit('close')">
          <img src="@/assets/icons/close.svg" alt="">
        </button>
      </div>
      <div class="content">
        <slot v-on:close="$emit('close')"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    title: {
      type: String,
      default: '...',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  z-index: 100;

  &-overlay {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    background: #000;
    opacity: 0.8;
  }

  &-content {
    z-index: 101;
    position: fixed;
    top: auto;
    bottom: 0;
    left: 60px;
    padding: 30px 18px;
    width: calc(100vw - 60px);
    background: #fff;
    box-sizing: border-box;

    .header {
      margin: 0 15px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .title {
        font-size: 20px;
        font-weight: bold;
        color: $primary;
      }

      .subtitle {
        margin-left: 64px;
        font-size: 12px;
        font-weight: bold;
        color: $surfaceDarker;
      }

      .ccs-button {
        margin-left: auto;
        justify-self: flex-end;
      }

    }

  }

}
</style>
